export default "__VITE_ASSET__7c39d8b1__"